import React, {Component} from 'react';
import MaterialIcon from '../../../MaterialIcon';
import ValueTypeSelector from "../ValueTypeSelector";
import defaultOperationOptions from "./const/defaultOperationOptions";
import defaultSwitchOperationOptions from "./const/switch/defaultSwitchOperationOptions";
import contextModifierPredicateTypes
    from "../ContextPropertyInputPortList/ContextPropertyModifier/contextModifierPredicateTypes";
import contextModifierOperationOptions
    from "../ContextPropertyInputPortList/ContextPropertyModifier/contextModifierOperationOptions";
import defaultTypes from "./const/defaultTypes";
import defaultSwitchTypes from "./const/switch/defaultSwitchTypes";
import searchFirstOperators from "./const/searchFirstOperators";
import defaultOperators from "./const/defaultOperators";

export default class PredicateItem extends Component {
    constructor(props) {
        super(props);

        this.state = {
            comparisonOptions: this.props.comparisonOptions,
            equalsOptions: this.props.equalsOptions,
            fuzzyMatchOptions: this.props.fuzzyMatchOptions,
            startsWithOptions: this.props.startsWithOptions,
            hasValueOptions: this.props.hasValueOptions,
            fullTextSearchOptions: this.props.fullTextSearchOptions,
            hasEventOptions: this.props.hasEventOptions,
            conditionState: this.props.conditionState,
            type: this.props.type,
            operator: this.props.operator,
            hasInputCount: this.props.hasInputCount,
            predicateBlockType: this.props.predicateBlockType
        };

        switch (this.state.predicateBlockType) {
            case "switch":
                this.defaultOperationOptions = defaultSwitchOperationOptions;
                this.types = defaultSwitchTypes;
                break;
            case "context_modifier":
            case "context_updater":
                this.defaultOperationOptions = contextModifierOperationOptions;
                this.types = contextModifierPredicateTypes;
                break;
            default:
                this.defaultOperationOptions = defaultOperationOptions;
                this.types = defaultTypes;
                break;
        }

        this.hasEventTypes = [
            {
                text: "Event type",
                xmlType: "constantValue"
            }
        ];

        this.operators = [];

        if (this.props.predicateBlockType === "searchFirst") {
            this.operators.push(...searchFirstOperators);
        }
        if (this.props.predicateBlockType !== "searchFirst") {
            this.operators.push(...defaultOperators);
        }

        this.operators.push(
            {
                type: "itemEquals",
                label: "Is one of / equals"
            },
            {
                type: "startsWith",
                label: "Starts With"
            },
            {
                type: "fullTextSearch",
                label: "Contains"
            },
            {
                type: "fullTextSearchAnalyzed",
                label: "Contains (Ignore case)"
            }
        );

        this.onClickSwitch = this.onClickSwitch.bind(this);
        this.onOperatorSwitch = this.onOperatorSwitch.bind(this);
        this.onPropertyValueChange = this.onPropertyValueChange.bind(this);
        this.createPropertySide = this.createPropertySide.bind(this);
        this.createRow = this.createRow.bind(this);

        let isOperatorValid = false;
        for (let operatorOptionIndex in this.operators) {
            if (this.state.operator === this.operators[operatorOptionIndex].type) {
                isOperatorValid = true;
            }
        }

        if (!isOperatorValid) {
            this.state.operator = this.operators[0].type;
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.type !== this.props.type) {
            this.setState({
                type: this.props.type
            });
        }
    }

    onOptionPropertyTypeChange(text, property, optionName) {
        let update = {};
        update[optionName] = {
            ...this.state[optionName]
        };

        update[optionName][property + "Type"] = this.types.find((type) => type.text === text).xmlType;
        update[optionName][property + "Value"] = '';

        if (property === "hasEvent") {
            update[optionName][property + "Value"] = text;
        }

        this.setState({
            ...update
        }, () => {
            this.props.onPredicateOptionUpdate(this.state);
        });

    }

    onOperatorSwitch(e) {
        const operator = e.target.value;
        let type = "";

        if (["equals", "notEquals", "lessThan", "lessThanOrEquals", "greaterThan", "greaterThanOrEquals"].includes(operator)) {
            type = "comparison";
        } else switch (operator) {
            case "itemEquals":
            case "itemEqualsAnalyzed":
                type = "equals";
                break;
            case "fuzzyMatch":
                type = "fuzzyMatch";
                break;
            case "startsWith":
            case "startsWithAnalyzed":
                type = "startsWith";
                break;
            case "hasValue":
                type = "hasValue";
                break;
            case "hasEvent":
                type = "hasEvent";
                break;
            case "fullTextSearch":
            case "fullTextSearchAnalyzed":
                type = "fullTextSearch";
                break;
            // case "itemEqualsAnalyzed":
            // case "startsWithAnalyzed":
            // case "fullTextSearchAnalyzed":
            //     type = operator;
            //     break;
        }

        const operationOptions = this.state[type + "Options"] ? {[type + "Options"]: {...this.state[type + "Options"]}} : {...this.defaultOperationOptions[type]};
        const newOptions = {
            ...operationOptions,
            operator,
            type
        };

        if (type === "comparison")
            newOptions.comparisonOptions.operator = operator;

        let options = {};
        switch (this.state.operator) {
            case "equals":
            case "notEquals":
            case "lessThan":
            case "lessThanOrEquals":
            case "greaterThan":
            case "greaterThanOrEquals": {
                options = {
                    ...this.defaultOperationOptions.comparison.comparisonOptions,
                    ...this.state.comparisonOptions
                };
                break;
            }
            case "itemEquals":
            case "itemEqualsAnalyzed": {
                options = {
                    ...this.defaultOperationOptions.equals.equalsOptions,
                    ...this.state.equalsOptions
                }
                break;
            }
            case "fuzzyMatch": {
                options = {
                    ...this.defaultOperationOptions.fuzzyMatch.fuzzyMatchOptions,
                    ...this.state.fuzzyMatchOptions
                }
                break;
            }
            case "startsWith":
            case "startsWithAnalyzed": {
                options.leftType = this.state.startsWithOptions.prefixType || this.defaultOperationOptions.startsWith.startsWithOptions.prefixType;
                options.leftValue = this.state.startsWithOptions.prefixValue || this.defaultOperationOptions.startsWith.startsWithOptions.prefixValue;
                options.rightType = this.state.startsWithOptions.fullTextType || this.defaultOperationOptions.startsWith.startsWithOptions.fullTextType;
                options.rightValue = this.state.startsWithOptions.fullTextValue || this.defaultOperationOptions.startsWith.startsWithOptions.fullTextValue;
                break;
            }
            case "hasValue": {
                options.leftType = this.state.hasValueOptions.propertyType || this.defaultOperationOptions.hasValue.hasValueOptions.propertyType;
                options.leftValue = this.state.hasValueOptions.propertyValue || this.defaultOperationOptions.hasValue.hasValueOptions.propertyValue;
                break;
            }
            case "fullTextSearch":
            case "fullTextSearchAnalyzed": {
                options.leftType = this.state.fullTextSearchOptions.searchInType || this.defaultOperationOptions.fullTextSearch.fullTextSearchOptions.searchInType;
                options.leftValue = this.state.fullTextSearchOptions.searchInValue || this.defaultOperationOptions.fullTextSearch.fullTextSearchOptions.searchInValue;
                options.rightType = this.state.fullTextSearchOptions.searchStringType || this.defaultOperationOptions.fullTextSearch.fullTextSearchOptions.searchStringType;
                options.rightValue = this.state.fullTextSearchOptions.searchStringValue || this.defaultOperationOptions.fullTextSearch.fullTextSearchOptions.searchStringValue;
                break;
            }
        }

        this.copyOptions(newOptions, options);

        if (
            this.props.predicateBlockType === "searchFirst" &&
            this.state[this.state.type + "Options"]["searchBoostValue"]
        ) {
            newOptions[type + "Options"]["searchBoostValue"] = this.state[this.state.type + "Options"]["searchBoostValue"];
        }

        if (
            this.props.predicateBlockType === "searchFirst" &&
            this.state[this.state.type + "Options"]["slopValue"]
        ) {
            newOptions[type + "Options"]["slopValue"] = this.state[this.state.type + "Options"]["slopValue"];
        }
        if (
            this.props.predicateBlockType === "searchFirst" &&
            this.state[this.state.type + "Options"]["minShouldMatchValue"]
        ) {
            newOptions[type + "Options"]["minShouldMatchValue"] = this.state[this.state.type + "Options"]["minShouldMatchValue"];
        }

        this.setState(newOptions, () => {
            this.props.onPredicateOptionUpdate(this.state)
        });
    }

    copyOptions(newOptions, source) {
        // if (Object.keys(source) == 0) return;
        switch (newOptions.type) {
            case "comparison":
            case "equals":
            case "fuzzyMatch": {
                newOptions[newOptions.type + "Options"] = {
                    ...newOptions[newOptions.type + "Options"],
                    ...source
                }
                break;
            }
            case "startsWith": {
                newOptions.startsWithOptions = {
                    prefixType:  source.leftType || newOptions.startsWithOptions.prefixType,
                    prefixValue: source.leftValue || newOptions.startsWithOptions.prefixValue,
                    fullTextType: source.rightType || newOptions.startsWithOptions.fullTextType,
                    fullTextValue: source.rightValue || newOptions.startsWithOptions.fullTextValue
                }
                break;
            }
            case "hasValue": {
                newOptions.hasValueOptions = {
                    propertyType: source.leftType || newOptions.hasValueOptions.propertyType,
                    propertyValue: source.leftValue || newOptions.hasValueOptions.propertyValue
                };
                break;
            }
            case "fullTextSearch":
            case "fullTextSearchAnalyzed": {
                newOptions.fullTextSearchOptions = {
                    searchInType: source.leftType || newOptions.fullTextSearchOptions.searchInType,
                    searchInValue: source.leftValue || newOptions.fullTextSearchOptions.searchInValue,
                    searchStringType: source.rightType || newOptions.fullTextSearchOptions.searchStringType,
                    searchStringValue: source.rightValue || newOptions.fullTextSearchOptions.searchStringValue,
                }
                break;
            }
        }
    }

    onClickSwitch() {
        this.setState(prevState => ({
            conditionState: !prevState.conditionState
        }), () => {
            this.props.onPredicateOptionUpdate(this.state);
        })
    }

    onPropertyValueChange(e, property, optionName) {
        const value = e.target.value || "";
        let update = {};
        update[optionName] = {...this.state[optionName]};
        update[optionName][property + "Value"] = value;

        this.setState({
            ...this.state,
            ...update
        }, () => {
            this.props.onPredicateOptionUpdate(this.state);
        })
    }
    createOperatorSelect() {
        return (
            <div className="operation predicate-box">
                
                <select value={this.state.operator} onChange={this.onOperatorSwitch} disabled={this.props.disableArea ? true : false}>
                    {this.operators.sort(
                        (a, b) => a.label > b.label ? 1 : -1
                    ).map((operator, index) => (
                        <option key={index} value={operator.type}>{operator.label}</option>
                    ))}
                </select>
            </div>
        )
    }

    createRow() {
        return (
            <>
                <MaterialIcon icon="more_vert"/>
                <div className="predicate-item-content">

                {(this.state.type === "comparison" || this.state.prevType === "comparison") && this.createPropertySide("left")}
                {(this.state.type === "equals" || this.state.prevType === "equals") && this.createPropertySide("left")}
                {(this.state.type === "fuzzyMatch" || this.state.prevType === "fuzzyMatch") && this.createPropertySide("left")}
                {(this.state.type === "startsWith" || this.state.prevType === "startsWith") && this.createPropertySide("prefix")}
                {(this.state.type === "hasValue" || this.state.prevType === "hasValue") && this.createPropertySide("property")}
                {(this.state.type === "fullTextSearch" || this.state.prevType === "fullTextSearch") && this.createPropertySide("searchIn")}
                {(this.state.type === "fullTextSearchAnalyzed" || this.state.prevType === "fullTextSearchAnalyzed") && this.createPropertySide("searchIn")}

                {this.createOperatorSelect()}

                {(this.state.type === "comparison" || this.state.prevType === "comparison") && this.createPropertySide("right")}
                {(this.state.type === "equals" || this.state.prevType === "equals") && this.createPropertySide("right")}
                {(this.state.type === "fuzzyMatch" || this.state.prevType === "fuzzyMatch") && this.createPropertySide("right")}
                {(this.state.type === "startsWith" || this.state.prevType === "startsWith") && this.createPropertySide("fullText")}
                {(this.state.type === "fullTextSearch" || this.state.prevType === "fullTextSearch") && this.createPropertySide("searchString")}
                {(this.state.type === "fullTextSearchAnalyzed" || this.state.prevType === "fullTextSearchAnalyzed") && this.createPropertySide("searchString")}
                {(this.state.type === "hasEvent" || this.state.prevType === "hasEvent") && this.createPropertySide("hasEvent")}

                {this.props.predicateBlockType === "searchFirst" &&
                  <>
                    <div className="predicate-box boost">
                        <div className="type-selector">
                            <button>boost</button>
                        </div>
                        <input type="text"
                               value={this.state[this.state.type + "Options"]["searchBoost" + "Value"]}
                               onChange={(e) => this.onPropertyValueChange(e, "searchBoost", this.state.type + "Options")}
                        />
                    </div>
                    <div className="predicate-box">
                        <div className="type-selector">
                           <button>slop</button>
                        </div>
                        <input type="text"
                               value={this.state[this.state.type + "Options"]["slop" + "Value"]}
                               onChange={(e) => this.onPropertyValueChange(e, "slop", this.state.type + "Options")}
                        />
                    </div>
                    <div className="predicate-box">
                       <div className="type-selector">
                           <button>minShouldMatch,%</button>
                        </div>
                        <input type="text"
                               value={this.state[this.state.type + "Options"]["minShouldMatch" + "Value"]}
                               onChange={(e) => this.onPropertyValueChange(e, "minShouldMatch", this.state.type + "Options")}
                         />
                     </div>
                   </>
                 }
                </div>
                <div className={"switch" + (this.state.conditionState ? "" : " not")} onClick={this.onClickSwitch}>
                    <div className="switch-position"/>
                </div>

                <div className="delete" onClick={() => this.props.onPredicateDelete()}>
                    <MaterialIcon icon="close"/>
                </div>
            </>
        )
    }

    createPropertySide(property) {
        const optionName = (this.state.type !== "trueValue" ? this.state.type : this.state.prevType) + "Options";
        const types = property === "hasEvent" ? this.hasEventTypes : this.types.sort(
            (a, b) => a.text > b.text ? 1 : -1
        );
        const selectedType = this.state[optionName] === undefined ? "" : this.state[optionName][property + "Type"];
        return (
            <div className={"predicate-box " + property}>
                <ValueTypeSelector types={this.state.hasInputCount ? types : types.filter(({xmlType}) => xmlType !== "inputCount")}
                                    disableArea={this.props.disableArea}
                                    selectedType={selectedType}
                                    onTypeSelect={(index) => this.onOptionPropertyTypeChange(index, property, optionName)}/>

                {selectedType === "contextProperty" && (
                        <select className="predicate-select" onChange={(e) => this.onPropertyValueChange(e, property, optionName)}
                                value={this.state[optionName][property + "Value"]}>
                            <option className="select-placeholder" value="" disabled defaultValue>Please select an
                                option
                            </option>
                            {this.props.contextProperties && this.props.contextProperties.sort(
                                (a, b) => a.name > b.name ? 1 : -1
                            ).map((contextProp) => (
                                <option key={contextProp.name}>{contextProp.name}</option>
                            ))}
                            {this.state[optionName][property + "Value"] &&
                                !this.props.contextProperties.find(
                                    (prop) => prop.name === this.state[optionName][property + "Value"]
                                ) && (
                                    <option key={this.state[optionName][property + "Value"]}>
                                        {this.state[optionName][property + "Value"]}
                                    </option>
                                )}
                    </select>
                    )}

                {selectedType === "itemProperty" && (
                    <select  className="predicate-select" value={this.state[optionName][property + "Value"]}
                            onChange={(e) => this.onPropertyValueChange(e, property, optionName)}>
                        <option className="select-placeholder" value="" disabled defaultValue>Please select an option
                        </option>
                        {this.props.itemProperties && this.props.itemProperties.sort(
                            (a, b) => a > b ? 1 : -1
                        ).map((itemProp) => (
                            <option key={itemProp}>{itemProp}</option>
                        ))}
                    </select>
                )}

                {selectedType === "userProperty" && (
                    <select  className="predicate-select" value={this.state[optionName][property + "Value"]}
                            onChange={(e) => this.onPropertyValueChange(e, property, optionName)}>
                        <option className="select-placeholder" value="" disabled defaultValue>Please select an option
                        </option>
                        {this.props.userProperties && this.props.userProperties.sort(
                            (a, b) => a > b ? 1 : -1
                        ).map((userProp) => (
                            <option key={userProp}>{userProp}</option>
                        ))}
                    </select>
                )}

                {selectedType === "dynamicProperty" && (
                    <input type="text" defaultValue={this.state[optionName][property + "Value"]}
                           onBlur={(e) => this.onPropertyValueChange(e, property, optionName)}/>
                )}

                {selectedType === "constantValue" && (
                    <input type="text" value={this.state[optionName][property + "Value"]}
                           onBlur={(e) => this.onPropertyValueChange(e, property, optionName)}
                           onChange={(e) => this.onPropertyValueChange(e, property, optionName)}/>
                )}
            </div>
        )
    }

    render() {
        return (
            <div className="predicate-item">
                {this.createRow()}
            </div>
        );
    }
}
